export default __webpack_public_path__ + "static/media/partner (16).53143df8.png";